export default __webpack_public_path__ + "static/media/people.5fdcc197.png";